module.exports = __webpack_public_path__ + "img/mb-advantage-3.5a7d9856.png";